import React from 'react';
import { useRefreshBlock, asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { EventListDetailsDefaultView } from './partials/EventListDetailsDefaultView';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { Icons } from '../../components/atoms/SVG';
import { EventListDetailsEditView } from './partials/EventListDetailsEditView';

export type EventListProps = Views<DefaultView<EventListDetailsDefaultView> & EditView<EventListDetailsEditView>>;

export function EventListDetails({ views, activeView }: EventListProps) {
  const { t } = useSonTranslation('EventList');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();

  const buttons = views.edit
    ? createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        `EventList:views.edit`,
        DISPLAY_TYPE.COLLAPSIBLE,
        <EventListDetailsEditView {...views.edit} />,
      )
    : {};

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{
        text: t('headline'),
        hierarchy: 3,
        visible: true,
      }}
      refreshBlock={refresh}
      refreshCount={refreshCount}
      activeView={activeView}
      views={views}
      buttons={buttons}
    >
      <EventListDetailsDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const EventListDetailsBlock = asFetchableBlock(EventListDetails, BlockType.eventlistdetails);
